import Alpine from 'alpinejs';

// initialize alpineJS
Alpine.start();
